import { Box, Stack } from "@mui/material";
import { Icon } from "components";
import { useTheme } from "contexts";
import { Socials } from "assets/data";
import { SocialType } from "types";
import { EnumTheme } from "utils/enums";

type Props = {
  color?: string;
  size?: "small" | "medium" | "large" | undefined;
};

export const Social = (props: Props) => {
  const { theme } = useTheme();
  const isDark = theme.id === EnumTheme.Dark;

  return (
    <Stack direction="row" spacing={theme.spacing.xs} flexWrap="wrap">
      {Socials.map((item: SocialType) => {
        // Tag abbreviation for retro look
        const abbr =
          item.name.toLowerCase().includes("git") ? "GIT" :
          item.name.toLowerCase().includes("link") ? "LNK" :
          item.name.toLowerCase().includes("cv") || item.name.toLowerCase().includes("resume") ? "RCV" :
          item.name.toLowerCase().includes("mail") ? "MSG" :
          item.name.substring(0, 3).toUpperCase();

        return (
          <Box
            key={item.name}
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href={item.href}
            aria-label={item.name}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: theme.spacing.xs,
              px: theme.spacing.sm,
              py: theme.spacing.xxs,
              backgroundColor: theme.color.background.accent,
              border: `1px solid ${theme.color.border.color}`,
              boxShadow: `2px 2px 0px 0px ${theme.color.border.color}`,
              color: theme.color.font.color,
              fontFamily: '"Space Mono", monospace',
              fontSize: theme.font.xxs,
              fontWeight: theme.font.bold,
              textDecoration: "none",
              borderRadius: theme.border.square,
              transition: "transform 0.12s ease-in-out, box-shadow 0.12s ease-in-out, border-color 0.12s ease-in-out",
              "&:hover": {
                transform: "translate(-1px, -1px)",
                borderColor: isDark ? "#ffffff" : "#191b22",
                boxShadow: `3px 3px 0px 0px ${isDark ? "#000000" : "#191b22"}`,
                color: theme.color.primary.color,
              },
              "&:active": {
                transform: "translate(1px, 1px)",
                boxShadow: "none",
              },
            }}
          >
            <Icon.Svg
              name={item.icon}
              size={14}
              fill={theme.color.font.color}
            />
            <Box component="span" sx={{ letterSpacing: "0.06em" }}>
              {abbr}
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
};